import React, { memo, useEffect, useState } from 'react'
import { Button, HeadingText } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import { fptiCustomSetup, fptiCustomClick, serverData } from '../../utils'
import { PYPL_CONTACTUS_URL } from '../../constants/constants'

const LinkExpiredPage = memo((props) => {
  const [impressionDone, setImpressionDone] = useState(false)
  const { dsrFpti = {} } = props

  useEffect(() => {
    if (!impressionDone) {
      setImpressionDone(true)
      fptiCustomSetup(dsrFpti.LINK_EXPIRED_IMPRESSION)
    }
  }, [impressionDone, dsrFpti])

  const handleGetStarted = (event) => {
    event.preventDefault()
    fptiCustomClick(dsrFpti.CONTACT_US_LINK)
    location.href = PYPL_CONTACTUS_URL
  }

  return (
    <>
      <section className="page-body-container">
        <div className="inner-container">
          <section className="common-screen">
            <div className="icon-container">
              <img
                src={`https://${serverData.cdnHostName}/dataprivacy/digitalassets/dar/Group-100129.svg`}
                alt="link-expired"
              />
            </div>
            <HeadingText size="sm">
              <Message id="closedAccountPages.linkexpired.title" />
            </HeadingText>
            <div className="button-container">
              <Button
                theme="v2"
                id="getstartedbtn"
                onClick={handleGetStarted}
                secondary
                size="sm"
              >
                <Message id="closedAccountPages.linkexpired.contactus" />
              </Button>
            </div>
          </section>
        </div>
      </section>
    </>
  )
})
LinkExpiredPage.displayName = 'LinkExpiredPage'

export default LinkExpiredPage
